import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

export const depositSchema = z.object({
  /** Record ID, e.g. "d140323907" */
  id: z.string(),
  /** Hash record, e.g. "0x8f8eafdae905be705f2fb692767e8e08e89ebef0287c0647e0bff6d6031b205d" */
  txid: z.string(),
  /** Operation time, e.g. "1734524496" */
  timestamp: z
    .string()
    .regex(/^\d+$/)
    .transform((v) => Number(v) * 1000),
  /** Currency amount, e.g. "10" */
  amount: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Currency name, e.g. "USDT" */
  currency: z.string(),
  /** Deposit address, e.g. "0x4e4c5f527acf3d98145a26665ad7dc442acb654c452ba152e2473b3d6a89af35" */
  address: z.string(),
  /** Additional remarks */
  memo: z.string().nullable(),
  /** Record status */
  status: z.union([
    // - DONE: done
    z.literal('DONE'),
    // - CANCEL: cancelled
    z.literal('CANCEL'),
    // - REQUEST: requesting
    z.literal('REQUEST'),
    // - MANUAL: pending manual approval
    z.literal('MANUAL'),
    // - BCODE: GateCode operation
    z.literal('BCODE'),
    // - EXTPEND: pending confirm after sending
    z.literal('EXTPEND'),
    // - FAIL: pending confirm when fail
    z.literal('FAIL'),
    // - INVALID: invalid order
    z.literal('INVALID'),
    // - VERIFY: verifying
    z.literal('VERIFY'),
    // - PROCES: processing
    z.literal('PROCES'),
    // - PEND: pending
    z.literal('PEND'),
    // - DMOVE: required manual approval
    z.literal('DMOVE'),
    // - SPLITPEND: the order is automatically split due to large amount
    z.literal('SPLITPEND'),
  ]),
  /** Name of the chain, e.g. "APT" */
  chain: z.string(),
})

export type Deposit = z.infer<typeof depositSchema>
